<button mat-button *ngIf="canDownload(); else expand" (click)="downloadClick()">
  Download results
</button>
<ng-template #expand>
  <button mat-button *ngIf="canExpand()" (click)="toggleClick()">
    {{ getText() }}
  </button>
</ng-template>
